import { createSlice } from '@reduxjs/toolkit';
import { changeShipmentStatus, getFacilityBoxes } from './api';

export const IndiaShipmentManagementSlice = createSlice({

    name: 'indiaShipmentManagementSlice',
    initialState: {
        loading: false,
        error: '',
        data: [],
        changeShipmentStatusSuccessMessage: '',

    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getFacilityBoxes.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getFacilityBoxes.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data
        })
        builder.addCase(getFacilityBoxes.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(changeShipmentStatus.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(changeShipmentStatus.fulfilled, (state, action) => {
            state.loading = false;
            state.changeShipmentStatusSuccessMessage = action.payload.data?.message
        })
        builder.addCase(changeShipmentStatus.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clearError, clear } = IndiaShipmentManagementSlice.actions

export default IndiaShipmentManagementSlice.reducer